<template>
	<ul class="fc-profile-left-nav">
		<li>
			<router-link 
					class="fc-order" 
					:to="`${this.RouterConfig.MyOrders}`">
				MY ORDERS
			</router-link>
		</li>
    <li>
    	<router-link 
    			class="fc-credit" 
    			:to="`${this.RouterConfig.MyCredit}`">
				MY CREDIT
			</router-link>
    </li>
    <li>
    	<router-link 
    			class="fc-address" 
    			:to="`${this.RouterConfig.MyInformation}`">
				MY INFORMATION
			</router-link>
    </li>
    <li><a class="fc-logout" @click="logout">Logout</a></li>
	</ul>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'profile-left-nav',
  methods: {
    logout: function () {
      if (process.browser) {
        const _this = this
        $.confirm({
          title: 'Warning',
          content: 'Logout?',
          type: 'orange',
          useBootstrap: false,
          buttons: {
            tryAgain: {
              text: 'OK',
              action: function () {
                _this.$store.dispatch('profileLogin/logout')
                  .then(() => {
                    _this.$router.push(_this.RouterConfig.Home)
                  })
              }
            },
            close: function () {
            }
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.fc-profile-left-nav {
	list-style: none;
	padding: 0;
	border-right: 1px solid #d1d2d4;
  width: 150px;
  height: 300px;
	>li{
		>a{
      font-size: 11px;
		  font-weight: bold;
		  letter-spacing: 0.5px;
		  color: #111111;
		  padding:10px 0;
		  display: block;
      cursor: pointer;
      text-decoration: none;
	    &::before{
	      font-family: 'Ionicons';
	      font-size: 14px;
	      color: #009938;
	      margin-right: 10px;
	    }
	    &.fc-order::before{
	      content: "\f143";
	    }
	    &.fc-credit::before{
	      content: "\f205";
	    }
	    &.fc-address::before{
	      content: "\f448";
	    }
	    &.fc-logout::before{
	      content: "\f1b2";
	    }
	  }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/profile/LeftNavigator.vue